









import { Component, Mixins, Prop } from "vue-property-decorator";
import { DepartmentGroup } from "../../../domain/department";
import DepartmentListSelector from "../../department/selectors/DepartmentListSelector.vue";
import { DepartmentUserFilterableMixin } from "./mixins";

@Component({
  components: {
    DepartmentListSelector,
  },
})
export default class DepartmentListUserFilter extends Mixins(DepartmentUserFilterableMixin) {
  @Prop()
  departmentGroup: DepartmentGroup;
  
  scrollIntoView(): void {
    (this.$refs.selector as DepartmentListSelector).scrollIntoView();
  }
}
